<template>
  <v-card class="grey lighten-5 rounded-0">
    <div class="header pa-6 grey lighten-4">
      <div class="font-weight-medium">
        {{ mainCopy.publication.title }}
      </div>
      <div
        class="first-author-and-year caption grey--text text--darken-1"
      >
        {{ mainCopy.publication.firstAuthor() }}
        {{ mainCopy.publication.year }}
      </div>
    </div>
    <v-divider />
    <div v-for="(otherCopy, i) in duplicates" :key="otherCopy.id">
      <v-divider v-if="i > 0" />
      <duplicate-group-card-item
        :index="i + 1"
        :main-copy="mainCopy"
        :other-copy="otherCopy"
        @mark-as-duplicate="$emit('mark-as-duplicate', otherCopy)"
        @mark-as-not-duplicate="
          $emit('mark-as-not-duplicate', otherCopy)
        "
      />
    </div>
  </v-card>
</template>

<script>
import DuplicateGroupCardItem from './DuplicateGroupCardItem';
import { Reference } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'DuplicateGroupCard',
  components: { DuplicateGroupCardItem },
  props: {
    mainCopy: {
      type: Reference,
      required: true,
    },
    duplicates: {
      type: Array,
      required: true,
      validator: (duplicates) =>
        typeHelpers.isArrayOfType(duplicates, Reference),
    },
  },
  emits: ['mark-as-duplicate', 'mark-as-not-duplicate'],
};
</script>
